<template>
  <div class="container-fluid linha-separadora"></div>
</template>